import React from "react";
import FreshdeskTicketLink from "utils/FreshdeskTicketLink";
import {freshdeskTicketExport} from "utils/freshdeskTicket";

import API from "@beardeddevops/react.api";
import Types from "constants/Types";
import Framework from "@beardeddevops/react.framework";
import ReactTable from "react-table";
import moment from "moment";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import Select from "react-select";

class FeedbackResponses extends Framework.Components.Collection {
	constructor(props) {
		let model = new API.BuildClass(Types.Feedback_Responses._name, API.RequestType.READ_ALL);
		super(props, model);

		this.state.zoneOptions = [];
		this.state.selectedZones = [];

		const search = (props.history && props.history.location && props.history.location.search)
			|| (typeof window !== 'undefined' ? window.location.search : '')
			|| '';
		const params = new URLSearchParams(search);
		const feedbackZone = params.get('feedback_zone');
		if (feedbackZone) {
			const zoneId = parseInt(feedbackZone, 10);
			if (!Number.isNaN(zoneId) && zoneId > 0) {
				this.state.selectedZones = [{value: zoneId, label: `Zone #${zoneId}`}];
			}
		}
	}

	componentDidMount() {
		this.loadZoneOptions();
	}

	loadZoneOptions = async () => {
		const model = new API.BuildClass(Types.Regions_Feedback._name, API.RequestType.READ_ALL);
		model.limit = 5000;
		try {
			let payload = await model.submit(null, 'GET_ALL');
			payload = Object.keys(payload).map((key) => payload[key]);
			const items = payload[3] || [];
			const zoneOptions = items
				.map((zone) => ({
					value: zone.pkey,
					label: zone.name || `Zone #${zone.pkey}`,
				}))
				.sort((a, b) => a.label.localeCompare(b.label));

			const selectedZones = (this.state.selectedZones || []).map((selected) => {
				const match = zoneOptions.find((opt) => Number(opt.value) === Number(selected.value));
				return match || selected;
			});

			this.setState({zoneOptions, selectedZones});
		} catch (error) {
			// Table fetch is independent; options are best-effort.
		}
	}

	/**
	 * Same pattern as TimeOff / AutomatedEmails:
	 * keep state.filter as an object, mutate in place, then call fetchDataActual.
	 */
	fetchData = async (state) => {
		if (typeof this.state.filter === "undefined" || Array.isArray(this.state.filter)) {
			this.state.filter = {};
		}

		const zoneIds = (this.state.selectedZones || [])
			.map((zone) => Number(zone.value))
			.filter((id) => !Number.isNaN(id) && id > 0);

		if (zoneIds.length) {
			this.state.filter.feedback_zones = zoneIds;
		} else {
			delete this.state.filter.feedback_zones;
		}
		delete this.state.filter.feedback_zone;

		this.model.filter = this.state.filter;
		this.setState({loading: true});
		window.setTimeout(() => {
			this.fetchDataActual(state);
		}, 100);
	}

	handleZones = (value) => {
		this.state.selectedZones = value || [];
		this.setState({selectedZones: this.state.selectedZones}, () => {
			// Remount table so ReactTable re-issues onFetchData with proper page/sort state.
			this.reloadTable();
		});
	}

	clearFilters = () => {
		if (this.props.history) {
			this.props.history.replace('/admins/feedback_responses');
		}
		this.state.selectedZones = [];
		this.model.sort = 'created';
		this.model.order = 'desc';
		this.setState({
			key: Math.random(),
			filter: {},
			search: '',
			searchField: '',
			startDate: '',
			endDate: '',
			page: 0,
			limit: this.limit || 20,
			filterLocation: null,
			filterStatus: null,
			pages: 'Loading...',
			selectedZones: [],
		});
		localStorage.removeItem('table-preferences-' + this.tableStorageName);
	}

	render() {
		const {data, pages, limit, loading, selectedZones, zoneOptions} = this.state;
		const columns = [
			{
				Header: "Submitted",
				id: "created",
				style: {whiteSpace: "nowrap"},
				accessor: obj => (obj.created ? moment(obj.created).local().format('MM/DD/YYYY h:mm A') : '')
			},
			{
				Header: "Stars",
				id: "stars_clicked",
				accessor: obj => obj.stars_clicked ?? '-',
				width: 60,
			},
			{
				Header: "Zone",
				id: "feedback_zone_name",
				style: {whiteSpace: "nowrap"},
				accessor: obj => obj.feedback_zone_name || 'N/A',
			},
			{
				Header: "Customer",
				id: "customer_name",
				accessor: obj => obj.customer_name,
			},
			{
				Header: "Engineer",
				id: "engineer_name",
				accessor: obj => obj.engineer_name,
			},
			{
				Header: "FD#",
				id: "fresh_ticket",
				accessor: obj => freshdeskTicketExport(obj.fresh_ticket),
				width: 90,
				Cell: props => <FreshdeskTicketLink freshTicket={props.original.fresh_ticket} />,
			},
			{
				Header: "Ticket Closed",
				id: "ticket_closed",
				style: {whiteSpace: "nowrap"},
				accessor: obj => (obj.ticket_closed ? moment(obj.ticket_closed).local().format('MM/DD/YYYY h:mm A') : '-')
			},
			{
				Header: "Message",
				id: "message",
				style: {whiteSpace: "unset", flex: 1},
				accessor: obj => obj.message || '',
			},
		];

		return (
			<Card>
				<CardContent>
					<div className="table-bar">
						<div className="d-flex align-items-center" style={{width: '100%', gap: 8}}>
							{this.renderSearch('Customer Feedback')}
							<div style={{minWidth: 260, flex: '1 1 260px', zIndex: 20}}>
								<Select
									placeholder="Feedback Zone Select"
									isMulti
									isClearable
									value={selectedZones}
									onChange={this.handleZones}
									options={zoneOptions}
								/>
							</div>
							{this.renderHeaderRight("Customer Feedback", columns)}
						</div>
					</div>
					<ReactTable
						key={this.state.key}
						columns={columns}
						manual
						data={data}
						pages={pages}
						loading={loading}
						loadingText="Requesting Data"
						onFetchData={this.fetchData}
						expanderDefaults={{
							sortable: true,
							resizable: true,
							filterable: true,
							width: undefined
						}}
						defaultSorted={[
							{
								id: this.model.sort,
								desc: this.model.order === 'desc'
							}
						]}
						showPagination={true}
						defaultPageSize={limit}
						className="-striped -highlight"
						onPageSizeChange={this.onPageSizeChange}
						pageSize={limit}
					/>

					<Framework.Elements.LoadingSpinner isLoading={loading}/>
				</CardContent>
			</Card>
		)
	}
}

export default Framework.Components.withRootState(FeedbackResponses);
